"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("components/form/constants");
const snap_ui_input_connector_1 = __importDefault(require("components/form/snap-ui-input-connector"));
const React = __importStar(require("react"));
const redux_form_1 = require("redux-form");
class FormSectionVisibility extends React.Component {
    render() {
        return (React.createElement("div", { id: "visibility", className: "sui-border sui-p-4 sui-mb-2 sui-border-neutral-border sui-bg-neutral-background sui-rounded" },
            React.createElement("h3", { className: "sui-heading-md sui-font-normal sui-text-gray-40" }, "Visibility"),
            React.createElement("div", { id: "visibility-settings-form", className: "" },
                React.createElement(redux_form_1.FormSection, { name: "profile" },
                    React.createElement(redux_form_1.Field, { id: "isAgeHidden", name: "isAgeHidden", label: "Birthdate", className: "sui-mb-2", component: snap_ui_input_connector_1.default, type: "radio-tab", options: constants_1.VISIBILITY_TAB_OPTIONS })),
                React.createElement(redux_form_1.FormSection, { name: "contactInfos" },
                    React.createElement(redux_form_1.Field, { id: "isEmailAddressPrivate", name: "isEmailAddressPrivate", label: "Preferred email address", className: "sui-mb-2", component: snap_ui_input_connector_1.default, type: "radio-tab", options: constants_1.VISIBILITY_TAB_OPTIONS }),
                    React.createElement(redux_form_1.Field, { id: "isPhoneNumber1Private", name: "isPhoneNumber1Private", label: "Preferred contact phone", className: "sui-mb-2", component: snap_ui_input_connector_1.default, type: "radio-tab", options: constants_1.VISIBILITY_TAB_OPTIONS }),
                    React.createElement(redux_form_1.Field, { id: "isAddressPrivate", name: "isAddressPrivate", label: "Address", className: "sui-mb-2", component: snap_ui_input_connector_1.default, type: "radio-tab", options: constants_1.VISIBILITY_TAB_OPTIONS })))));
    }
}
exports.default = FormSectionVisibility;
